import { css, styled, thd, up, th } from '@smooth-ui/core-sc';
import { NavLink } from 'react-router-dom';

export default styled(NavLink)`
  border-left: 3px solid ${th('secondary')};
  color: ${thd('customMenuColor', '#54707c')};
  display: block;
  font-size: 20px;
  padding: 0.5em;
  ${props =>
    props.depth && props.depth > 1 && `padding-left: ${props.depth - 1}em;`}
  text-decoration: none;

  &:hover,
  &:focus {
    text-decoration: underline;
  }

  &:focus,
  &.menu-active:focus {
    outline: none;
    box-shadow: 0 0 0 0.2rem ${thd('customMenuFocus', 'rgba(84,112,124,0.25)')}
      inset;
  }

  &.menu-active {
    border-left-color: ${thd('customMenuHighlightColor', '#54707c')};
    color: ${thd('customMenuHighlightColor', '#000')};
    font-weight: bold;
    background-color: white;
  }

  ${up(
    'lg',
    css`
      font-size: 16px;
      ${props =>
        // If it's the top level
        (!props.depth || props.depth < 2) &&
        css`
          border-left: 0 none;
          margin-left: 0.7rem;
          margin-right: 0.7rem;
          padding: 0.25em 0.2em;
        `}

      &.menu-active {
        text-decoration: underline;
      }
    `
  )}
`;
